import React from "react";

import { TableCell, TableRow } from "@mui/material";
import clsx from "clsx";

import { Field } from "@safetyculture/s12-apis-connect-web/s12/users/userfield/v1/field_pb";

import mainStyles from "../../../styles";
import { CopyableId } from "./copyable-id";
import { mapFieldDataType } from "./utils";

type UserFieldsTableRowProps = {
  field: Field;
};

export const UserFieldsTableRow = (props: UserFieldsTableRowProps) => {
  const { field } = props;
  const classes = mainStyles();
  return (
    <TableRow data-testid="user-field-table-row">
      <TableCell
        className={clsx(classes.tableCell, classes.tableRightColPadding)}
        align="left"
      >
        {field.name}
        <CopyableId id={field.id} testId="user-field-id" />
      </TableCell>
      <TableCell
        className={clsx(classes.tableCell, classes.tableRightColPadding)}
        align="left"
      >
        {field.description || "-"}
      </TableCell>
      <TableCell
        className={clsx(classes.tableCell, classes.tableRightColPadding)}
        align="left"
      >
        {mapFieldDataType(field.dataType)}
      </TableCell>
      <TableCell
        className={clsx(classes.tableCell, classes.tableRightColPadding)}
        align="left"
      >
        {field.selectOptions.length === 0 ? (
          "-"
        ) : (
          <ul
            style={{
              textAlign: "left",
              paddingLeft: 0,
              margin: 0,
              listStylePosition: "inside",
            }}
          >
            {field.selectOptions.map((option) => (
              <li key={option.id} style={{ marginBottom: 4 }}>
                {option.label}
                <CopyableId id={option.id} testId="user-field-option-id" />
              </li>
            ))}
          </ul>
        )}
      </TableCell>
      <TableCell
        className={clsx(classes.tableCell, classes.tableRightColPadding)}
        style={{ minWidth: "100px" }}
        align="left"
      >
        {field.hasAttributes ? "Yes" : "No"}
      </TableCell>
    </TableRow>
  );
};
